import { Cached } from "@mui/icons-material";
import { Autocomplete, Box, Button, FormControl, FormControlLabel, FormGroup, Grid, InputLabel, OutlinedInput, styled, Switch, TextField, Typography } from "@mui/material"
import { showNotification } from "../../../../../common/Notification/ToastifyNotification";
import { ConnectionType, Network } from "../../../../../common/const";

const DefaultTypo = styled(Typography)(({ theme }) => ({
  color: 'gray',
  fontSize: 10
}));

const DefaultTypo1 = styled(Typography)(({ theme }) => ({
  color: 'red',
  fontSize: 10
}));

const TechConnection = ({
  itemData,
  items,
  setItems
}) => {
  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>Tech Connection</Typography>
          <Typography variant="body2" sx={{ fontSize: 12 }}>Specific equipment requirements related to technical attributes.</Typography>
        </Box>
        <Box>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            startIcon={<Cached />}
            onClick={() => {
              setItems((prevData) => ({
                ...prevData,
                product_data: {
                  ...prevData.product_data,
                  tech_connection_data: {
                    isConnection: itemData?.product?.tech_connection_data?.isConnection,
                    connectionType: itemData?.product?.tech_connection_data?.connectionType,
                    network: itemData?.product?.tech_connection_data?.network,
                    techRemarks: itemData?.product?.tech_connection_data?.techRemarks
                  }
                }
              }));
            }}
          >
            Reset Section
          </Button>
        </Box>
      </Box>
      <Grid container spacing={2} mt={0.5}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  checked={items?.product_data?.tech_connection_data?.isConnection}
                  onClick={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        tech_connection_data: {
                          ...prevData.product_data?.tech_connection_data,
                          isConnection: e.target.checked,
                          connectionType: e.target.checked ? items?.product_data?.tech_connection_data?.connectionType : null,
                          network: e.target?.checked ? items?.product_data?.tech_connection_data?.network : null,
                          techRemarks: e.target?.checked ? items?.product_data?.tech_connection_data?.techRemarks : null,
                        }
                      }
                    }))
                  }}
                />}
              label="Has Technical Connections"
            />
          </FormGroup>
          {items?.product_data?.tech_connection_data?.isConnection !== itemData?.product?.tech_connection_data?.isConnection && (
            <Box display="flex" alignItems="center">
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{itemData?.product?.tech_connection_data?.isConnection ? 'Yes' : 'No'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        {items?.product_data?.tech_connection_data?.isConnection && (
          <>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <Autocomplete
                value={ConnectionType.find((c) => c.value === items?.product_data?.tech_connection_data?.connectionType) || null}
                id="combo-box-demo"
                size="small"
                fullWidth
                options={ConnectionType}
                getOptionLabel={(option) => option?.name}
                onChange={(event, newValue) => {
                  setItems((prevData) => ({
                    ...prevData,
                    product_data: {
                      ...prevData.product_data,
                      tech_connection_data: {
                        ...prevData.product_data?.tech_connection_data,
                        connectionType: newValue?.value || null
                      }
                    }
                  }));
                }}
                renderInput={(params) => <TextField fullWidth {...params} label="Connection Type" name="Connection Type" variant="outlined" />}
              />
              {items?.product_data?.tech_connection_data?.connectionType !== itemData?.product?.tech_connection_data?.connectionType && (
                <Box display="flex" alignItems="center">
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{ConnectionType.find((c) => c.value === itemData?.product?.tech_connection_data?.connectionType)?.name || '--'}</DefaultTypo1>
                </Box>
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <Autocomplete
                value={Network.find((c) => c.value === items?.product_data?.tech_connection_data?.network) || null}
                id="combo-box-demo"
                size="small"
                fullWidth
                options={Network}
                getOptionLabel={(option) => option?.name}
                onChange={(event, newValue) => {
                  setItems((prevData) => ({
                    ...prevData,
                    product_data: {
                      ...prevData.product_data,
                      tech_connection_data: {
                        ...prevData.product_data?.tech_connection_data,
                        network: newValue?.value || null
                      }
                    }
                  }));
                }}
                renderInput={(params) => <TextField fullWidth {...params} label="Network" name="Network" variant="outlined" />}
              />
              {items?.product_data?.tech_connection_data?.network !== itemData?.product?.tech_connection_data?.network && (
                <Box display="flex" alignItems="center">
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{Network.find((c) => c.value === itemData?.product?.tech_connection_data?.network)?.name || '--'}</DefaultTypo1>
                </Box>
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <FormControl size="small" fullWidth variant="outlined">
                <InputLabel htmlFor="standard-adornment-password">Technical Remarks</InputLabel>
                <OutlinedInput
                  label="Technical Remarks"
                  id="standard-adornment-password"
                  type='text'
                  multiline
                  minRows={5}
                  value={items?.product_data?.tech_connection_data?.techRemarks}
                  onChange={(e) => {
                    if (e.target.value?.length > 300) {
                      showNotification('The Remarks should be maximum 300 characters long', 'error');
                    } else {
                      setItems((prevData) => ({
                        ...prevData,
                        product_data: {
                          ...prevData.product_data,
                          tech_connection_data: {
                            ...prevData.product_data?.tech_connection_data,
                            techRemarks: e.target.value || null
                          }
                        }
                      }));
                    }
                  }}
                />
              </FormControl>
              {items?.product_data?.tech_connection_data?.techRemarks !== itemData?.product?.tech_connection_data?.techRemarks && (
                <Box display="flex" alignItems="center">
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{itemData?.product?.tech_connection_data?.techRemarks || '--'}</DefaultTypo1>
                </Box>
              )}
            </Grid>
          </>
        )}
      </Grid>
    </>
  )
}

export default TechConnection;